import styled from 'styled-components';
import { useRef, useState } from 'react';
import { Modal, ModalTitle, ModalBody, ModalFooter, MODAL_OUTER_PADDING } from 'design-system/src/components/Modal';
import { Typography } from 'design-system/src/components/Typography/Typography';
import Button from 'design-system/src/components/Button/Button';
import NotificationSettings, { NotificationSettingsHandle } from '../NotificationSettings';

const ModalSubtitle = styled(Typography)`
  margin: 0 ${MODAL_OUTER_PADDING};
`;

export type ManageNotificationsModalProps = {
  onClose: () => void;
  memberId: string;
  memberName?: string;
};

const ManageNotificationsModal = ({ onClose, memberId, memberName }: ManageNotificationsModalProps) => {
  const settingsRef = useRef<NotificationSettingsHandle>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <Modal onClose={onClose} wide fullHeight>
      <ModalTitle>Manage notifications</ModalTitle>
      {memberName && (
        <ModalSubtitle>
          For{' '}
          <Typography renderedAs="span" weight={600}>
            {memberName}
          </Typography>
        </ModalSubtitle>
      )}
      <ModalBody>
        <NotificationSettings
          memberId={memberId}
          onSaveSuccess={onClose}
          ref={settingsRef}
          onSubmittingChange={setIsSubmitting}
        />
      </ModalBody>
      <ModalFooter>
        <Button size="lg" width="full" onClick={() => settingsRef.current?.save()} isLoading={isSubmitting}>
          Save settings
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ManageNotificationsModal;
